import { GAME_ID } from 'a/doubleTrouble/data/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initialState = {};

const gameDetailsReducer = (state = initialState, { gameId, type, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
      return {
        ...state,
        ...(stateData[GAME_ID].GameData || {}).gameDetails,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
